import { jwtDecode } from "jwt-decode";
import { Tokens, User } from "../types/rokaTypes";

const COGNITO_DOMAIN = "https://login.rmcounting.no";
const COGNITO_CLIENT_ID = "3bvsvd4s7ofq1nr0ktnpp9cea8";
const CALLBACK_URL = `${window.location.origin}/login`;

// https://docs.aws.amazon.com/cognito/latest/developerguide/federation-endpoints.html
const COGNITO_TOKEN_ENDPOINT = `${COGNITO_DOMAIN}/oauth2/token`;
const COGNITO_REVOKE_TOKEN_ENDPOINT = `${COGNITO_DOMAIN}/oauth2/revoke`;
const COGNITO_LOGOUT_ENDPOINT = `${COGNITO_DOMAIN}/logout?client_id=${COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(CALLBACK_URL)}`;

export const getTokens = async (authorizationCode: string): Promise<Tokens> =>
  fetch(COGNITO_TOKEN_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      grant_type: "authorization_code",
      client_id: COGNITO_CLIENT_ID,
      redirect_uri: CALLBACK_URL,
      code: authorizationCode,
    }),
  })
    // TODO: Handle common errors
    .then((res) => res.json())
    .then((json) => {
      /* Example response:
              { 
                "access_token":"eyJra1example", 
                "id_token":"eyJra2example",
                "refresh_token":"eyJj3example",
                "token_type":"Bearer", 
                "expires_in":3600
                }
             */
      return {
        accessToken: json["access_token"],
        idToken: json["id_token"],
        refreshToken: json["refresh_token"],
        expiresAt: Date.now() + parseInt(json["expires_in"], 10) * 1000,
      };
    });

export const refreshTokens = (refreshToken: string): Promise<Tokens> =>
  fetch(COGNITO_TOKEN_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      grant_type: "refresh_token",
      client_id: COGNITO_CLIENT_ID,
      refresh_token: refreshToken,
    }),
  })
    // TODO: Handle common errors
    .then((res) => res.json())
    .then((json) => {
      /* Example response:
              { 
                "access_token":"eyJra1example", 
                "id_token":"eyJra2example",
                "expires_in":3600
                }
             */
      return {
        accessToken: json["access_token"],
        idToken: json["id_token"],
        expiresAt: Date.now() + parseInt(json["expires_in"], 10) * 1000,
        refreshToken,
      };
    });

export const revokeToken = async (refreshToken: string) => {
  try {
    await fetch(COGNITO_REVOKE_TOKEN_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        token: refreshToken,
        client_id: COGNITO_CLIENT_ID,
      }),
    });
  } catch (error) {
    console.error("Error revoking token", error);
  }
};

export const redirectToCognitoLogout = () => {
  window.location.href = COGNITO_LOGOUT_ENDPOINT;
};

interface CognitoIdToken {
  "cognito:username": string;
  name: string; // maps to site
  "custom:is_admin": string; // maps to isAdmin
}

export const getUserInfo = (idToken: string): User => {
  const decoded = jwtDecode<CognitoIdToken>(idToken);
  return {
    username: decoded["cognito:username"],
    site: decoded.name,
    isAdmin: decoded["custom:is_admin"] === "AbsoluteWay",
    isDisabled: false,
  };
};
